import { getData } from './index';
import {
  CORREDOR_GP_GET_LIST,
  CORREDOR_GP_GET_PROD_MENSUAL,
  CORREDOR_GP_GET_PROD_MENSUAL_SUMMARY,
  CORREDOR_GP_GET_SUMMARY,
  CORREDOR_GP_UPDATE_LIST_URLS,
  CORREDOR_GP_UPDATE_PROD_MENSUAL_LIST_URLS
} from '../constants/action-types';
import { API, BASE_URL } from '../../CONST';


export const getPolicies = filterParams => dispatch => {
  const baseUrl = `${BASE_URL}${API.garantiasIntermediarios}`;
  dispatch(getData({
    url: `${baseUrl}/?${filterParams}`,
    type: CORREDOR_GP_GET_LIST,
  }));
  dispatch(getData({
    url: `${baseUrl}/summary/?${filterParams}`,
    type: CORREDOR_GP_GET_SUMMARY,
  }));
  dispatch({
    type: CORREDOR_GP_UPDATE_LIST_URLS,
    payload: {
      xlsxUrl: `${baseUrl}/xlsx/?${filterParams}`,
      pdfUrl: `${baseUrl}/pdf/?${filterParams}`,
    },
  })
};


export const getPoliciesPorMes = (datesFilter, corredor) => dispatch => {
  const { startDate, endDate } = datesFilter;
  const baseUrl = `${BASE_URL}${API.garantiasIntermediarios}`;
  let filterParams = `desde_ano=${startDate.year()}&desde_mes=${startDate.month() + 1}&hasta_ano=${endDate.year()}&hasta_mes=${endDate.month() + 1}`;

  if (corredor) {
    filterParams = `${filterParams}&corredor_id=${corredor.id}`
  }

  dispatch(getData({
    url: `${baseUrl}/summary/?por_mes&${filterParams}`,
    type: CORREDOR_GP_GET_PROD_MENSUAL,
  }));
  dispatch(getData({
    url: `${baseUrl}/summary/?${filterParams}`,
    type: CORREDOR_GP_GET_PROD_MENSUAL_SUMMARY,
  }));
  dispatch({
    type: CORREDOR_GP_UPDATE_PROD_MENSUAL_LIST_URLS,
    payload: {
      xlsxUrl: `${baseUrl}/xlsx_prod_mensual/?${filterParams}`,
      pdfUrl: `${baseUrl}/pdf_prod_mensual/?${filterParams}`,
    },
  })
};
